import { getAuth, GoogleAuthProvider, signInWithRedirect } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import { getFirestore } from 'firebase/firestore';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

firebase.initializeApp(config);

export const auth = getAuth();
export const db = getFirestore();

const providerGoogle = new GoogleAuthProvider();

providerGoogle.setCustomParameters({ prompt: 'select_account' });

export const signInWithGoogle = async () => {
  if (!auth) return Promise;
  signInWithRedirect(auth, providerGoogle);
};
export const logout = () => auth?.signOut();
